export const IMPOTS_LESSONS_AR = [
  {
    id: 'impots-1',
    numero: 1,
    titre: "فهم التصريح بالدخل",
    sousTitre: "لماذا ومتى؟",
    contexte: "كل سنة في أبريل-مايو، يُصرّح الفرنسيون بدخلهم. لكن لماذا بالضبط، وماذا يحدث إن لم نفعل ذلك؟",
    explication: [
      "**التصريح بالدخل** يتيح للدولة حساب الضريبة التي تدين بها — أو المبلغ الذي يمكن إرجاعه إليك.",
      "**من يجب أن يُصرّح؟** كل شخص بالغ يقيم في فرنسا، حتى لو لم يكن لديك دخل أو كنت معفياً من الضرائب.",
      "**متى تُصرّح؟** كل سنة بين أبريل ويونيو. الموعد النهائي يختلف حسب مقاطعتك — تحقق على impots.gouv.fr.",
      "**إذا لم تُصرّح**، تخاطر بغرامة 10% على ضريبتك، ثم زيادات إضافية. في حالة الشك، صرّح دائماً.",
      "**خبر جيد**: إذا صرّحت العام الماضي، معلوماتك محشوّة مسبقاً. في الغالب يكفي التحقق والتأكيد.",
    ],
    question: "من يجب أن يُقدّم تصريحاً بالدخل في فرنسا؟",
    options: [
      { id: 'a', text: "كل شخص بالغ يقيم في فرنسا، حتى بدون دخل", correct: true },
      { id: 'b', text: "فقط الأشخاص الذين يدفعون ضرائب", correct: false },
      { id: 'c', text: "فقط الموظفون بعقد دائم CDI", correct: false },
    ],
    explication_reponse: "الجميع يجب أن يُصرّح، حتى بدون دخل — هذا يتيح للدولة حساب حقوقك في بعض المساعدات. عدم التصريح قد يؤدي إلى غرامات، حتى لو لم تكن خاضعاً للضريبة.",
  },
  {
    id: 'impots-2',
    numero: 2,
    titre: "إنشاء حسابك الشخصي على impots.gouv.fr",
    sousTitre: "الاتصال الأول",
    contexte: "كل شيء يتم إلكترونياً على impots.gouv.fr. الخطوة الأولى هي إنشاء أو استرجاع فضائك الشخصي.",
    explication: [
      "**الموقع الرسمي** هو impots.gouv.fr — هذا الموقع فقط. احذر من المواقع المشابهة ذات العنوان المختلف.",
      "**الرقم الضريبي** (numéro fiscal) مكوّن من 13 رقماً، موجود في أعلى يسار إشعار الضريبة. إذا لم يكن لديك، اتصل بـ 0809 401 401.",
      "**إنشاء الحساب**: على impots.gouv.fr ← 'إنشاء فضائي' ← أدخل رقمك الضريبي وتاريخ ميلادك.",
      "**رمز التفعيل** يُرسل بالبريد إلى منزلك خلال 5-7 أيام. هذا إجراء أمني عادي — انتظر.",
      "**بعد التفعيل**: يمكنك الوصول إلى تصريحاتك، إشعاراتك، مراسلاتك مع الضرائب.",
    ],
    question: "أين تجد رقمك الضريبي (numéro fiscal)؟",
    options: [
      { id: 'a', text: "في أعلى يسار إشعار الضريبة", correct: true },
      { id: 'b', text: "على بطاقة الهوية", correct: false },
      { id: 'c', text: "على بطاقة الناخب", correct: false },
    ],
    explication_reponse: "الرقم الضريبي موجود في أعلى يسار إشعار الضريبة الخاص بك. إذا فقدت إشعارك، اتصل بـ 0809 401 401 (مجاني) للحصول عليه.",
  },
  {
    id: 'impots-3',
    numero: 3,
    titre: "ملء التصريح",
    sousTitre: "خطوة بخطوة",
    contexte: "الوقت قد حان لملء التصريح. بفضل الملء المسبق، الأمر أبسط مما تتخيل.",
    explication: [
      "**الملء المسبق**: صاحب العمل يُرسل بياناتك مباشرة إلى الضرائب. تصريحك محشوّ مسبقاً بمرتباتك.",
      "**الخانة 1AJ** (أو 1BJ لزوجك): هي المكان الذي تُدخل فيه مرتباتك السنوية. تحقق من المبلغ مع ورقة راتبك الأخيرة.",
      "**تحقق من جميع المعلومات**: العنوان، الوضع العائلي، الأطفال المعالون. كل خطأ قد يغيّر مبلغ ضريبتك.",
      "**التعديل مسموح**: إذا لاحظت خطأً في المبلغ المحشوّ مسبقاً، صحّحه مباشرة — لن تتعرض لأي عقوبة.",
      "**التحقق النهائي**: انقر على 'التحقق' ثم 'التحقق والإرسال'. ستتلقى إيصال إرسال — احتفظ به.",
    ],
    question: "مرتباتك محشوّة مسبقاً في التصريح لكنها خاطئة. ماذا تفعل؟",
    options: [
      { id: 'a', text: "أصحح المبلغ مباشرة — مسموح وضروري", correct: true },
      { id: 'b', text: "أقبل المبلغ دون تعديل لتجنب المشاكل", correct: false },
      { id: 'c', text: "لا أُرسل التصريح وأنتظر اتصال الضرائب", correct: false },
    ],
    explication_reponse: "يجب دائماً تصحيح المبالغ الخاطئة. تصريح بمبلغ خاطئ قد يعني دفع ضريبة أكثر مما يجب — أو أقل، مما يؤدي إلى طلب الاسترداد لاحقاً.",
  },
  {
    id: 'impots-4',
    numero: 4,
    titre: "فهم إشعار الضريبة",
    sousTitre: "تفسير وثيقتك",
    contexte: "استلمت إشعارك. ماذا تعني كل هذه الأرقام، وهل تدفع أم تسترد؟",
    explication: [
      "**الدخل المرجعي للضريبة** (revenu fiscal de référence): مجموع دخلك بعد الخصومات. يُستخدم لحساب حقك في العديد من المساعدات الاجتماعية.",
      "**إذا كان المبلغ موجباً**: تدين للدولة بضريبة — تُسحب مباشرة من حسابك.",
      "**إذا كان المبلغ سالباً**: الدولة تُعيد لك مبلغاً — يُودَع في حسابك في غضون أغسطس.",
      "**الإعفاء من الضريبة**: إذا كان دخلك أقل من عتبة معينة، أنت معفى — لكن عليك التصريح على أي حال.",
      "**الإشعار يُخزَّن**: على impots.gouv.fr يمكنك الوصول إلى جميع إشعاراتك السابقة. مفيد جداً للطلبات الاجتماعية.",
    ],
    question: "إشعار ضريبتك يُظهر مبلغاً سالباً. ماذا يعني ذلك؟",
    options: [
      { id: 'a', text: "الدولة تُعيد لك مبلغاً — سيُودَع في حسابك", correct: true },
      { id: 'b', text: "أنت مديون للدولة ويجب الدفع", correct: false },
      { id: 'c', text: "هناك خطأ في التصريح ويجب الاتصال بالضرائب", correct: false },
    ],
    explication_reponse: "المبلغ السالب في إشعار الضريبة يعني استرداداً لصالحك. يُودَع عادةً في أغسطس مباشرة في حسابك البنكي المسجّل.",
  },
];
